import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // To access dynamic route parameters
import axios from "axios";
import config from "../../config";
import useAxios from "../../utils/useAxios";

const Moderate = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(""); // State to track selected event
  const [posts, setPosts] = useState([]); // State to hold fetched posts
  const [loading, setLoading] = useState(true);
  const [totaleventPosts, setTotaleventPosts] = useState(0); // Total number of eventPosts
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); // Track selected status
  const [selectedPost, setSelectedPost] = useState({
    person_name: "",
    person_email_id: "",
    person_city: "",
    caption: "",
    media_url: "",
    thumbnail_media_url: "",
    media_file_type: "",
    created_at: "",
  });

  const axiosAPI = useAxios()

  useEffect(() => {
    const fetchEventPosts = async () => {
      try {
        const postsResponse = await axiosAPI("/api/events/get-all-event-posts")

        const postsResponseData = postsResponse.data;

        // Calculate the total mediaFiles
        setTotaleventPosts(postsResponseData.length);

        // Extract events list from the posts
        const uniqueEvents = [
          ...new Set(postsResponseData.map((post) => post.event_name)),
        ]; // Ensure only unique events are listed

        setEvents(uniqueEvents);

        setPosts(postsResponseData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching event details or posts", error);
        setLoading(false);
      }
    };

    fetchEventPosts();
  }, []); // Rerun this effect when eventUrlSlug changes

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!posts) {
    return <div>Event not found!</div>;
  }

  // Function to toggle the favourite status of a post
  const toggleFavourite = async (post) => {
    const updatedPost = {
      ...post,
      is_favourite: post.is_favourite === "yes" ? "no" : "yes",
    }; // Toggle between 'yes' and 'no'

    try {
      // Update the post's favourite status in the database
      await axios.put(
        `${config.apiBaseUrl}/api/events/update-event-post-favourite/${post.id}`,
        { is_favourite: updatedPost.is_favourite }
      );

      window.notifyMessage("Success", "Favourite status updated");

      // Update local state to reflect the change
      setPosts((prevPosts) =>
        prevPosts.map((p) =>
          p.id === post.id
            ? { ...p, is_favourite: updatedPost.is_favourite }
            : p
        )
      );
    } catch (error) {
      window.notifyMessage(
        "Error",
        "Error updating favourite status",
        "danger"
      );
      console.error("Error updating favourite status", error);
    }
  };

  const updatePostStatus = async (post, status) => {
    try {
      // Send the new status to the backend
      await axios.put(
        `${config.apiBaseUrl}/api/events/update-event-post-status/${post.id}`,
        { status }
      );

      window.notifyMessage("Success", "Status updated");

      // Update the post status locally after a successful update
      setPosts((prevPosts) =>
        prevPosts.map((p) => (p.id === post.id ? { ...p, status: status } : p))
      );
    } catch (error) {
      window.notifyMessage("Error", "Error updating post status", "danger");
      console.error("Error updating status:", error);
    }
  };

  // Handle input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle status filter change
  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
  };

  // Handle event filter change
  const handleEventFilterChange = (event) => {
    setSelectedEvent(event);
  };

  // Filter posts based on search query and selected status
  const filteredPosts = posts
    .filter(
      (post) =>
        post.caption.toLowerCase().includes(searchQuery.toLowerCase()) ||
        post.person_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        post.person_city.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .filter((post) => (statusFilter ? post.status === statusFilter : true)) // Apply status filter if selected
    .filter((post) =>
      selectedEvent ? post.event_name === selectedEvent : true
    ); // Apply event filter if selected

  const timeAgo = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(date)) / 1000);

    // Calculate the difference in various units
    const seconds = diffInSeconds;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30); // Approximate months as 30 days
    const years = Math.floor(months / 12);

    // Determine the appropriate time difference format
    if (years > 0) return `${years} year${years > 1 ? "s" : ""} ago`;
    if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
    if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    if (seconds > 0) return `${seconds} second${seconds > 1 ? "s" : ""} ago`;

    return "Just now";
  };

  // Function to truncate captions to a max of 120 characters
  const truncateCaption = (caption) => {
    if (caption && caption.length > 120) {
      return caption.substring(0, 120) + "...";
    }
    return caption;
  };

  const openPostModal = (post) => {
    setSelectedPost(post);
    showModal("postModal");
    // console.log({ media });
  };

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  return (
    <div className="social-wall-main">
      <main className="container mb-3" role="main">
        <div className="card my-4">
          <div className="card-body">
            <div className="d-flex mb-2 align-items-center">
              <div className="flex-grow-1">
                <div className="card-title text-uppercase fs-6">
                  All Event Posts
                  <br />
                  <div className="form-text">
                    Total Posts - {totaleventPosts}
                  </div>
                </div>
              </div>
              <div>
                <div className="d-flex">
                  <input
                    className="form-control me-2 rounded-pill"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
              <div>
                <div className="d-flex">
                  {/* Event Select Dropdown */}
                  <select
                    className="form-select me-2"
                    onChange={(e) => handleEventFilterChange(e.target.value)}
                    value={selectedEvent}
                  >
                    <option value="">All Events</option>
                    {events.map((event, index) => (
                      <option key={index} value={event}>
                        {event}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <i
                  className={`fa fa-filter cursor-pointer fs-3 ${
                    statusFilter ? "" : ""
                  }`}
                  style={{ color: statusFilter ? "blue" : "gray" }} // Blue if filter applied, gray if no filter
                  aria-hidden="true"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></i>
                <div className="dropdown-menu">
                  <button
                    className={`dropdown-item ${
                      statusFilter === "" ? "active" : ""
                    }`}
                    onClick={() => handleStatusFilterChange("")} // Reset the status filter
                  >
                    All
                  </button>
                  <button
                    className={`dropdown-item ${
                      statusFilter === "pending" ? "active" : ""
                    }`}
                    onClick={() => handleStatusFilterChange("pending")}
                  >
                    Pending
                  </button>
                  <button
                    className={`dropdown-item ${
                      statusFilter === "approve" ? "active" : ""
                    }`}
                    onClick={() => handleStatusFilterChange("approve")}
                  >
                    Approve
                  </button>
                  <button
                    className={`dropdown-item ${
                      statusFilter === "private" ? "active" : ""
                    }`}
                    onClick={() => handleStatusFilterChange("private")}
                  >
                    Private
                  </button>
                  <button
                    className={`dropdown-item ${
                      statusFilter === "banned" ? "active" : ""
                    }`}
                    onClick={() => handleStatusFilterChange("banned")}
                  >
                    Banned
                  </button>
                  <button
                    className={`dropdown-item ${
                      statusFilter === "delete" ? "active" : ""
                    }`}
                    onClick={() => handleStatusFilterChange("delete")}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" id="m-posts-container">
          {filteredPosts.map((post) => (
            <div
              key={post.id}
              className={`col-12 col-sm-6 col-md-4 col-lg-3 posts-container-column`}
            >
              <div className="card">
                <div className="position-relative">
                  {/* Media - Image or Video */}
                  {post.media_file_type === "image" ? (
                    // <img
                    //   src={
                    //     "/assets/img/placeholder.png" ||
                    //     post.thumbnail_media_url
                    //   } // Default image URL if no media is available
                    //   className="card-img-top img-fluid custom-card-height cursor-pointer "
                    //   alt="Post Image"
                    //   onClick={() => openPostModal(post)}
                    // />
                    <img
                      src={post.thumbnail_media_url}
                      onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = "/assets/img/placeholder.png";
                      }}
                      className="card-img-top img-fluid custom-card-height cursor-pointer"
                      alt="Post Image"
                      onClick={() => openPostModal(post)}
                    />
                  ) : (
                    <>
                      {/* <img
                        src={
                          "/assets/img/placeholder.png" ||
                          post.thumbnail_media_url
                        } // Default image URL if no media is available
                        className="card-img-top img-fluid custom-card-height cursor-pointer "
                        alt="Post Image"
                        onClick={() => openPostModal(post)}
                      /> */}

                      <img
                        src={post.thumbnail_media_url}
                        onError={(e) => {
                          e.target.onerror = null; // prevent infinite loop
                          e.target.src = "/assets/img/placeholder.png";
                        }}
                        className="card-img-top img-fluid custom-card-height cursor-pointer"
                        alt="Post Image"
                        onClick={() => openPostModal(post)}
                      />

                      <div
                        className="position-absolute top-50 start-50 translate-middle cursor-pointer"
                        style={{ zIndex: 10 }}
                        onClick={() => openPostModal(post)}
                      >
                        <i
                          className="fa fa-play-circle text-white fs-1 shadow cursor-pointer"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </>
                  )}
                  <div
                    className="position-absolute top-0 end-0 custom-card-img-overlay"
                    onClick={() => toggleFavourite(post)}
                  >
                    <i
                      className={`fa fa-star star-icon ${
                        post.is_favourite === "yes" ? "text-danger" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div className="card-body pt-1">
                  <div className="d-flex justify-content-between">
                    <span className="fw-bold text-truncate">
                      {post.person_name}
                    </span>
                    <span className="text-muted">{post.person_city}</span>
                  </div>
                  <p className="text-muted small mb-3 pt-2 caption-area">
                    {truncateCaption(post.caption) || "No caption available"}
                  </p>
                  <div className="d-flex justify-content-around m-action-button-icons">
                    <button
                      type="button approve"
                      className={`btn ${
                        post.status === "approve" ? "active" : ""
                      }`}
                      onClick={() => updatePostStatus(post, "approve")}
                    >
                      <i className="fa fa-check"></i>
                    </button>
                    <button
                      type="button private"
                      className={`btn ${
                        post.status === "private" ? "active" : ""
                      }`}
                      onClick={() => updatePostStatus(post, "private")}
                    >
                      <i className="fa fa-eye-slash"></i>
                    </button>
                    <button
                      type="button banned"
                      className={`btn ${
                        post.status === "banned" ? "active" : ""
                      }`}
                      onClick={() => updatePostStatus(post, "banned")}
                    >
                      <i className="fa fa-exclamation-circle"></i>
                    </button>
                    <button
                      type="button delete"
                      className={`btn ${
                        post.status === "delete" ? "active" : ""
                      }`}
                      onClick={() => updatePostStatus(post, "delete")}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className="modal fade"
          id="postModal"
          tabIndex="-1"
          aria-labelledby="postModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="d-flex justify-content-end p-2">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  {/* <i className="fa fa-times-circle fs-4 text-secondary"></i> */}
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-2">
                    {selectedPost.media_file_type == "image" ? (
                      <img
                        src={selectedPost.media_url}
                        className="img-fluid rounded"
                        alt="Sample Image"
                      />
                    ) : (
                      <video
                        id="player"
                        className="w-100 rounded shadow-sm"
                        controls
                        src={selectedPost.media_url}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "60vh",
                        }}
                      ></video>
                    )}
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="d-flex align-items-center mb-3">
                      <i className="fa fa-twitter text-primary me-2 fs-5"></i>
                      <p className="mb-0">{selectedPost.person_city}</p>
                      <a
                        href="https://www.tiktok.com/player/v1/7448944345257921814"
                        className="ms-auto text-muted small text-decoration-none"
                        target="_blank"
                        rel="nofollow noopener"
                      >
                        {timeAgo(selectedPost.created_at)}
                      </a>
                    </div>
                    <p className="text-dark mb-2">{selectedPost.person_name}</p>
                    <p className="text-muted small mb-3">
                      {selectedPost.caption}
                    </p>
                    <div className="d-flex gap-2">
                      <a
                        className="btn btn-info btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-facebook text-white fs-5"></i>
                      </a>
                      <a
                        className="btn btn-primary btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-twitter text-white fs-5"></i>
                      </a>
                      <a
                        className="btn btn-danger btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-linkedin text-white fs-5"></i>
                      </a>
                      <a
                        className="btn btn-success btn-sm rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                        href="#"
                        role="button"
                      >
                        <i className="fa fa-link text-white fs-5"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="no-posts"
          className="text-center text-muted"
          style={{ display: filteredPosts.length === 0 ? "block" : "none" }}
        >
          <p>No posts found!</p>
        </div>
      </main>
    </div>
  );
};

export default Moderate;
